import { ConciergeBellIcon, CrownIcon, DumbbellIcon, HandHelpingIcon, JoystickIcon } from "lucide-react";

export interface Agent {
  agentId: string;
  customName?: string;
  icon?: React.ReactNode;
  id: string;
  name?:
    | "agents.chess_coach"
    | "agents.concierge"
    | "agents.game_character"
    | "agents.support_agent"
    | "agents.trainer";
}

export interface Voice {
  colors: [string, string];
  customName?: string;
  id: string;
  name?: "voices.eric" | "voices.jessica" | "voices.lily" | "voices.matilda" | "voices.will";
  orb: string;
  voiceId: string;
}

export const VOICES: Voice[] = [
  {
    name: "voices.jessica",
    id: "a",
    colors: ["#6DB035", "#F5CABB"],
    voiceId: "cgSgspJ2msm6clMCkdW9",
    orb: "/assets/images/convai/peach-orb.png",
  },
  {
    name: "voices.lily",
    id: "b",
    colors: ["#2792DC", "#9CE6E6"],
    voiceId: "pFZP5JQG7iQjIQuC4Bku",
    orb: "/assets/images/convai/blue-orb.png",
  },
  {
    name: "voices.eric",
    id: "e",
    colors: ["#CBA252", "#FFE769"],
    voiceId: "cjVigY5qzO86Huf0OWal",
    orb: "/assets/images/convai/gold-orb.png",
  },
  {
    name: "voices.will",
    id: "d",
    colors: ["#9e93e6", "#e3b6f7"],
    voiceId: "bIHbv24MWmeRgasZH58o",
    orb: "/assets/images/convai/purple-orb.png",
  },
  {
    name: "voices.matilda",
    id: "c",
    colors: ["#92cb7b", "#e2e98d"],
    voiceId: "XrExE9yKIg1WjnnlVkGX",
    orb: "/assets/images/convai/green-orb.png",
  },
];

export const AGENTS: Agent[] = [
  { name: "agents.support_agent", id: "g", agentId: "orQpg0d8k3qnIealQBEw", icon: <HandHelpingIcon size={20} /> },
  { name: "agents.chess_coach", id: "h", agentId: "v9iBXo6WErRBLZsukvQV", icon: <CrownIcon size={20} /> },
  { name: "agents.game_character", id: "f", agentId: "L6ac8PK5xaoIwbngt2hZ", icon: <JoystickIcon size={20} /> },
  { name: "agents.concierge", id: "i", agentId: "mk73wOm4o1e5hcnljAwB", icon: <ConciergeBellIcon size={20} /> },
  { name: "agents.trainer", id: "j", agentId: "saJQtx3EP8B5LScj7OSg", icon: <DumbbellIcon size={20} /> },
];
